import BaseApi from "./BaseApi";

class ActivityLogApi extends BaseApi {
  async list(data = {}) {
    return this.API({
      url: "/activity-log/list",
      data,
      method: "post",
    });
  }

  async listByEntity(entityType, entityId) {
    return this.API({
      url: `/activity-log/entity/${entityType}/${entityId}`,
      method: "get",
    });
  }
}

export default ActivityLogApi;
